import axios from "axios";
import { baseUrl } from "../utils/baseUrl";
import { axiosInterceptors } from "../components/Reusable/axiosInterceptors";

const instance = axios.create({
    baseURL: `${baseUrl}/api/Customer`,
    headers: {
        "Content-Type": "application/json",
    },
});
axiosInterceptors(instance)
export default instance;
